export default __webpack_public_path__ + "static/media/Speed.d19181f2.svg";